import React, { useState } from "react";
import { MoneyInput } from "../../../components/MoneyInput";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../../lib/api";
import { apiErr } from "../../../lib/apiErr";
import { provName } from "./llmUtil";

const toForm = (s) => ({ budgets: Object.fromEntries(Object.entries(s.budgets || {}).map(([k, v]) => [k, v == null ? "" : String(v)])), thresholds: (s.thresholds || []).join(", ") });

export function BudgetForm({ settings, onSaved }) {
  const [f, setF] = useState(() => toForm(settings));
  const [busy, setBusy] = useState(false);
  const orig = toForm(settings);
  const dirty = JSON.stringify(f) !== JSON.stringify(orig);
  const ths = f.thresholds.split(/[,\s]+/).filter(Boolean).map(Number);
  const thErr = !ths.length || ths.some((n) => !Number.isInteger(n) || n < 1 || n > 100) ? "Ambang harus bilangan bulat 1–100, pisahkan dengan koma" : "";
  const bErr = Object.values(f.budgets).some((v) => v !== "" && (Number.isNaN(Number(v)) || Number(v) < 0)) ? "Anggaran harus angka ≥ 0 atau kosong" : "";
  const save = async () => {
    setBusy(true);
    try {
      const budgets = Object.fromEntries(Object.entries(f.budgets).map(([k, v]) => [k, v === "" ? null : Number(v)]));
      const r = await api.put("/admin/llm/settings", { budgets, thresholds: [...new Set(ths)].sort((a, b) => a - b) });
      onSaved(r.data); setF(toForm(r.data)); toast.success("Anggaran disimpan");
    } catch (e) { toast.error(apiErr(e, "Gagal menyimpan anggaran")); } finally { setBusy(false); }
  };
  return (
    <div className="aivora-card p-5" data-testid="llm-budget-form">
      <p className="text-sm font-bold text-slate-900">Anggaran bulanan key sendiri (USD)</p>
      <p className="mt-0.5 text-xs text-slate-500">Kosongkan untuk tanpa anggaran (tanpa peringatan). Peringatan dikirim sekali per provider/bulan/ambang.</p>
      <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {Object.keys(f.budgets).map((k) => (
          <label key={k} className="text-xs font-semibold text-slate-600">{provName(k)}
            <MoneyInput currency="USD" decimals={2} placeholder="Tanpa anggaran" value={f.budgets[k]} onValue={(v) => setF((x) => ({ ...x, budgets: { ...x.budgets, [k]: v } }))} className="mt-1" testid={`llm-budget-${k}`} />
          </label>
        ))}
      </div>
      <label className="mt-4 block max-w-sm text-xs font-semibold text-slate-600">Ambang peringatan (%)
        <input value={f.thresholds} onChange={(e) => setF((x) => ({ ...x, thresholds: e.target.value }))} placeholder="80, 95" className="input-ui mt-1" data-testid="llm-thresholds" />
      </label>
      {(thErr || bErr) && <p className="mt-2 text-xs font-semibold text-rose-600" data-testid="llm-budget-error">{bErr || thErr}</p>}
      <div className="mt-4 flex justify-end gap-2">
        {dirty && <button onClick={() => setF(orig)} className="btn-soft rounded-xl px-4 py-2 text-xs font-bold" data-testid="llm-budget-reset">Batalkan</button>}
        <button onClick={save} disabled={!dirty || busy || !!thErr || !!bErr} className="btn-primary inline-flex items-center gap-1.5 rounded-xl px-4 py-2 text-xs font-bold disabled:opacity-50" data-testid="llm-budget-save">{busy ? <Loader2 size={12} className="animate-spin" /> : <Save size={12} />} Simpan</button>
      </div>
    </div>
  );
}
